<template>
	<div class="order_wrap">
		<nuxt-link :to="`/article/list/${teacher.id}`" target="_blank" rel="noopener">
			<div><i class="cjg iconfont icon-cjg"></i></div>
			<p>藏金阁</p>
		</nuxt-link>
		<nuxt-link v-if="teacher.trainingId" :to="`/vip/detail/${teacher.id}`" target="_blank" rel="noopener">
			<div><i class="vip iconfont icon-txb"></i></div>
			<p>特训班</p>
		</nuxt-link>
		<a v-else @click="showTip" href="javascript:void(0)">
			<div><i class="vip iconfont icon-txb"></i></div>
			<p>特训班</p>
		</a>
		<nuxt-link to="/user/viewpoint" target="_blank" rel="noopener">
			<div><i class="jiamiguandain iconfont icon-jiamiguandian"></i></div>
			<p>加密观点</p>
		</nuxt-link>
		<nuxt-link to="/user/fcoins" target="_blank" rel="noopener">
			<div><i class="shouzhimingxi iconfont icon-shouzhimingxi1"></i></div>
			<p>收支明细</p>
		</nuxt-link>
		<nuxt-link :to="`/room/history-list/${teacher.id}`">
			<div><i class="lishizhibo iconfont icon-rizhiguanli"></i></div>
			<p>直播历史</p>
		</nuxt-link>
	</div>
</template>

<script>
import Dialog from '@/utils/Dialog'

export default {
	methods: {
		showTip () {
      if (this.isRoomTeacher) {
        Dialog.alert('您尚未创建特训班，是否前去创建？', {
          showCancelButton: true
        }).then(() => {
          this.$router.push('/vip/edit')
        })
      } else {
        Dialog.alert('老师尚未创建特训班')
      }
    }
	},
	computed: {
		teacher () {
			return this.$store.state.teacher.data
		},
		isRoomTeacher () {
			return this.$store.getters['teacher/isTeacher']
		}
	}
}
</script>

<style lang="less" scoped>
.order_wrap {
	height: 85px; border-top: 1px solid #dadada;
	a {
		display: block; box-sizing: content-box; float: left; width: 82px; height: 84px; text-align: center; color: #3B3B3B;
		&:not(:last-child) {
			border-right: 1px solid #dadada;
		}
		div {
			height: 50px; line-height: 50px;
			i { transition: all 0.3s; }
			.cjg { font-size: 34px; }
			.vip { font-size: 30px; }
			.jiamiguandain { font-size: 29px;}
			.shouzhimingxi {  font-size: 25px; }
			.lishizhibo { font-size: 28px; }
		}

		&:hover { color: #ff9a00;
			i { font-weight: 700; }
			.cjg { font-size: 37px; }
			.vip { font-size: 32px; }
			.jiamiguandain { font-size: 31px; }
			.shouzhimingxi {  font-size: 27px; }
			.lishizhibo { font-size: 30px; }
		}
	}
}
</style>
